import { render, staticRenderFns } from "./modal-adicional.vue?vue&type=template&id=478bf003&scoped=true&"
import script from "./modal-adicional.vue?vue&type=script&lang=js&"
export * from "./modal-adicional.vue?vue&type=script&lang=js&"
import style0 from "./modal-adicional.vue?vue&type=style&index=0&id=478bf003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478bf003",
  null
  
)

export default component.exports